import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class TranslationUtils {

    constructor(private translate: TranslateService) { }

    getTranslatedMessage(key: string, replaceValue: string): string {
        const message = this.translate.instant(key);
        return message.replace('{0}', replaceValue);
    }
}
